<template>
  <div class="container-fluid permissions-page">
    <div class="title-container">
      <h3 class="title">
        Permission table
        <div
          class="spinner-border spinner-theme_default"
          role="status"
          v-if="!isLoaded"
        >
          <span class="sr-only">
            Loading...
          </span>
        </div>
      </h3>
    </div>
    <TableForPage
      style="margin-bottom: 0;"
      v-if="tableItems.length"
      :isLoading="isLoaded"
      :tableData="tableItems"
      :fields="headerFields"
      :cellFixed="false"
      stickyHeader
    />
  </div>
</template>

<script>
import TableForPage from '@tables/TableForPage'

export default {
  name: 'Permission',
  components: {
    TableForPage
  },
  data () {
    return {
      isLoaded: false,
      permission: {

      },
      permissions_map: {
        c: 'create',
        cown: 'create_own',
        uall: 'update_all',
        uown: 'update_own',
        rall: 'read_all',
        rown: 'read_own',
        d: 'delete',
        down: 'delete_own'
      }
    }
  },
  computed: {
    headerFields () {
      let entities = Object.keys(this.permission.administrator)
      entities.unshift('Role name')
      return entities
    },
    tableItems () {
      const rolesKeys = Object.keys(this.permission)
      const entitiesesKeys = Object.keys(this.permission.administrator)
      const permissionsMapKeys = Object.keys(this.permissions_map)
      let tableItemsArr = []
      rolesKeys.map(role => {
        let item = {
          'Role name': role.replace('_', ' ')
        }
        entitiesesKeys.map(entities => {
          item[entities] = []
          if (this.permission[role][entities]) {
            this.permission[role][entities].map(elem => {
              permissionsMapKeys.map(perm => {
                if (perm === elem) {
                  item[entities].push(this.permissions_map[perm])
                }
              })
            })
          }
          item[entities] = item[entities].join(', \n')
        })
        tableItemsArr.push(item)
      })
      return tableItemsArr
    }
  },
  async created () {
    try {
      await this.$api.permission.getAllPermission()
      this.permission = { ...this.$store.getters.getAllPermission.permission }
      this.isLoaded = true
    } catch (e) {
      throw (e)
    }
  }
}
</script>

<style lang="scss">
.permissions-page {
  .b-table-sticky-header{
     max-height: calc(100vh - 200px)
  }

  tbody{
     tr{
       td:nth-child(1){
         &::first-letter{
           text-transform: uppercase
         }
         font-weight: 600;
       }
     }
  }
}

</style>
